/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTrfV1TrfSessionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRF_V1_TRF_SESSION_EVENT_ENTITY_NAME = 'ixc.trf.v1.TrfSessionEvent';
export const ixcTrfV1TrfSessionEventEntity = new schema.Entity<IxcTrfV1TrfSessionEvent>(IXC_TRF_V1_TRF_SESSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTrfV1TrfSessionEvent) => `${entity.metadata?.eventId}` });

